var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    { staticClass: "breadcrumb" },
    [
      _c(
        "pp-breadcrumb",
        { attrs: { separator: "\\" } },
        _vm._l(_vm.pathMap, function (route) {
          return _c(
            "pp-breadcrumb-item",
            { key: route.id, attrs: { href: route.path } },
            [_vm._v(_vm._s(route.name))]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }